module.exports = __webpack_public_path__ + "f81a37385a91b6332df12f9c59e26b4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_3_2023_chart.png
// module id = 1740
// module chunks = 0